import {
    AfterViewInit,
    Component,
    Input,
    ViewEncapsulation
} from '@angular/core';
import { Response } from '@angular/http';
import { CommonHttpService } from '../../../../../shared/services/http.service';

@Component({
    selector: 'account-subscriptions-details-plan-details-current-cycle',
    templateUrl: './account.subscriptions.details.plan-details.current-cycle.component.html',
    styleUrls: ['./../../../../account.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AccountSubscriptionsDetailsPlanDetailsCurrentCycleComponent implements AfterViewInit {
    @Input('plan') plan;
    @Input('client') client;
    @Input('subscription') subscription;
    public cycle: Cycle;

    constructor(
        protected http: CommonHttpService
    ) { }

    ngAfterViewInit() {
        this.http.useAuth().get(
            `/account/clients/${this.client.id}`
            + `/subscriptions/${this.subscription.id}`
            + `/plan/current-cycle`
        ).subscribe((response: Response) => {
            this.cycle = response.json().data;
        });
    }

    public date(dateString) {
        return new Date(dateString);
    }
    /**
     * Get extra fields and values from item's extra fields.
     **/
    public getExtraFields(item) {
        return Object
        .keys(item.extra_fields)
        .map(slug => item.extra_fields[slug]);
    }
}


// WEBPACK FOOTER //
// /codebuild/output/src560599644/src/src/app/account/subscriptions/details/plan-details/current-cycle/account.subscriptions.details.plan-details.current-cycle.component.ts